import React, { useEffect, useState } from "react";
import LiquidationFirst from "./LiquidationFirst";
import OtpSection from "./OtpSection";
import LiquidationSucess from "./LiquidationSucess";
import { getQuoteRequest } from "../services/waitlist-service";
import { toast } from "react-toastify";
import Loader from "react-loaders";


export default function LiquidationBondsMain(props) {
    const [marksView, setMarksView] = useState([true, false, false, false]);
    const [marksDone, setMarksDone] = useState(new Array(3).fill(false));
    const [showSecond, setShowSecond] = useState(false);
    const [showFinal, setShowFinal] = useState(false)
    const [units, setUnits] = useState(1);
    const [otp, setOtp] = useState("");

    function updateOtp(val) {
        setOtp(val);
    }

    const increaseUnits = () => {
        if (units < props.liquidationDetails.availableUnits) {
            setUnits((units) => Number(units) + 1)
        } else {
            toast.error("Entered units cannot be more than Total available units")
        }
    };

    const decreaseUnits = () => {
        if (units > 1) {
            setUnits((units) => Number(units) - 1);
        }
    };

    const setUnitsFunc = (val) => {
        const result = val.replace(/[^0-9]/g, "");
        if (result <= props?.liquidationDetails?.availableUnits) {
            setUnits(Number(result));
        } else {
            return toast.error("You don’t have sufficient units")
        }
    };

    function verifyOtp() {
        getQuoteRequest(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, units, otp).then(
            (res) => {
                if (res.success) {
                    setShowSecond(false)
                    setShowFinal(true)
                } if (!res.success) {
                    toast.error(res.message);
                }
            },
            (err) => {
                toast.error("OTP invalid", err);
            }
        );
    }

    function resendOtp() {
        getQuoteRequest(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, props.units, 0).then(
            (res) => {
                if (res) {
                    toast.success("OTP sent sucessfully")
                }
            },
            (err) => {
                toast.error("Error calling the API:", err);
            }
        );
    }

    useEffect(() => {
        if (showFinal) {
            let mark = [...marksView]
            mark[2] = true
            setMarksView(mark)
        }
    }, [showFinal])

    useEffect(() => {
        if (showSecond) {
            let mark = [...marksView]
            mark[1] = true
            setMarksView(mark)
        }
    }, [showSecond])

    return (
        <>
            {!props?.loader ?
                <div className="liquidation-dashboard">
                    <div className="payment-modal-body">
                        <div className="navi-logo-div">
                            <img className="second-img" src={props?.bondDetails?.logoUrl} alt="logo"/>
                        </div>
                        <div className="mark-main-2">
                            <div className="marks">
                                <img src={process.env.REACT_APP_IMAGES_PATH + "txMark.webp"} alt="txMark-icon"/>
                                {marksView[0] && <div className="mdi-holder"></div>}
                                {marksDone[0] && <div className="mdi-holder"></div>}
                                {!marksView[0] && !marksDone[0] && <div className="rounded" />}
                                <div className="text">Request Liquidation</div>
                            </div>
                            <div className="marks">
                                <img src={process.env.REACT_APP_IMAGES_PATH + "signMark.webp"} alt="signMark-icon"/>
                                {marksView[1] && <div className="mdi-holder"></div>}
                                {marksDone[1] && <div className="mdi-holder"></div>}
                                {!marksView[1] && !marksDone[1] && <div className="rounded" />}
                                <div className="text">OTP Confirmation</div>
                            </div>
                            <div className="marks">
                                <img src={process.env.REACT_APP_IMAGES_PATH + "progress5.webp"} alt="progress5-icon"/>
                                {marksView[2] && <div className="mdi-holder"></div>}
                                {marksDone[2] && <div className="mdi-holder"></div>}
                                {!marksView[2] && !marksDone[2] && <div className="rounded" />}
                                <div className="text">Liquidation Order Placed</div>
                            </div>
                            <div className="marks">
                                <img src={process.env.REACT_APP_IMAGES_PATH + "progress6.webp" } alt="progress6-icon"/>
                                {marksView[3] && <div className="mdi-holder"></div>}
                                {marksDone[3] && <div className="mdi-holder"></div>}
                                {!marksView[3] && !marksDone[3] && <div className="rounded" />}
                                <div className="text">Liquidation Order Processed</div>
                            </div>

                        </div>
                        {(marksView[0]) && (
                            <LiquidationFirst
                                marksDone={marksDone}
                                setMarksDone={setMarksView}
                                showSecond={setShowSecond}
                                showButton={showSecond}
                                increaseUnits={increaseUnits}
                                decreaseUnits={decreaseUnits}
                                setUnitsFunc={setUnitsFunc}
                                units={units}
                                bondDetails={props?.bondDetails}
                                liquidationDetails={props?.liquidationDetails}
                                redemptionSuccess={props?.redemptionSuccess}
                            />
                        )}
                        {showSecond && (
                            <div className="text-center">
                                <OtpSection
                                    userEmail={props?.userEmail}
                                    phone={props?.phone}
                                    verifyOtp={verifyOtp}
                                    updateOtp={updateOtp}
                                    bondDetails={props?.bondDetails}
                                    otp={otp}
                                    resendOtp={resendOtp}
                                    showSecond={showSecond}
                                    product={props.bondDetails.productType}
                                />
                            </div>
                        )}
                        {showFinal && (
                            <LiquidationSucess
                                bondDetails={props?.bondDetails}
                                product={props.bondDetails.productType}
                            />
                        )}
                    </div>
                </div> :
                <Loader type="ball-clip-rotate" />
            }
        </>

    );
}
